import React from 'react';
import PropTypes from 'prop-types';
// import { Auth } from 'aws-amplify';
import classNames from 'classnames';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Hidden, Paper, Typography, Container } from '@material-ui/core';
import { Switch, Route } from 'react-router-dom';

import authBgImg from 'Images/AuthPageBG.png';
import flyttaLogoFull from 'Images/flytta_logo_full.png';
import { APP_ROUTES } from 'Utils/appShell';
import {
  SignInForm,
  SignInLanding,
  ForgotPassword,
} from 'Containers/auth/signIn';
import { SignOutLanding } from 'Containers/auth/signOut';

const styles = theme => ({
  authBgImg: {
    width: '100%',
    height: '100%',
    filter: 'invert(1)',
  },
  flyttaLogoFull: {
    width: 160,
    height: 60,
  },
  limitContentWidth: {
    [theme.breakpoints.down('md')]: {
      maxWidth: 720,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 720,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1080,
    },
  },
  flexOccupyItem: {
    flexGrow: 1,
  },
  flexGrowItem: {
    flexGrow: 2,
  },
});

class AuthLandingRoot extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid
        container
        direction="row"
        spacing={0}
        className={classNames('fillScreen')}
      >
        <Hidden mdDown>
          <Grid item lg={5}>
            <Paper elevation={0} square>
              <img src={authBgImg} className={classes.authBgImg} />
            </Paper>
          </Grid>
        </Hidden>
        <Grid item md={12} lg={7}>
          <Paper square className={classNames('fullHeight')}>
            <Container
              className={classNames(classes.limitContentWidth, 'fullHeight')}
            >
              <Grid container direction="column" className={'fullHeight'}>
                <Grid item className={classes.flexOccupyItem} />
                <Grid
                  container
                  direction="column"
                  alignItems="flex-start"
                  justify="center"
                  spacing={3}
                  className={classes.flexGrowItem}
                >
                  <Grid item>
                    <img
                      src={flyttaLogoFull}
                      className={classes.flyttaLogoFull}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="h3" paragraph>
                      Welcome to Flytta
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      paragraph
                      className={classes.fitContentWidth}
                    >
                      Join the family of over one million people who are
                      relocating their employees with Flytta
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Switch>
                      <Route
                        path={APP_ROUTES.AUTH_SIGNIN}
                        exact
                        component={SignInForm}
                      />
                      <Route
                        path={APP_ROUTES.AUTH_FORGOT_PASSWORD}
                        exact
                        component={ForgotPassword}
                      />
                      <Route
                        path={APP_ROUTES.AUTH_SIGNIN_LANDING}
                        component={SignInLanding}
                      />
                      <Route
                        path={APP_ROUTES.AUTH_SIGNED_OUT}
                        component={SignOutLanding}
                      />
                    </Switch>
                  </Grid>
                </Grid>
                <Grid item className={classes.flexOccupyItem} />
              </Grid>
            </Container>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

AuthLandingRoot.propTypes = {
  classes: PropTypes.object.isRequired,
};

AuthLandingRoot = compose(withStyles(styles, { withTheme: true }))(
  AuthLandingRoot
);

export default AuthLandingRoot;
